import { GET_AVAILABLE_COUNTERS } from '../actions/actionTypes';

const initialState: Array<any> = [];

export const counterReducer = (state: any[] = initialState, action: any) => {

  switch (action.type) {

    case GET_AVAILABLE_COUNTERS:
      return [ ...action.data ];
    default:
      return state;
  }
};